// Copyright (C) 2021 TANNER AG

import React, { useEffect } from "react";
import { compose, withProps } from "recompose";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withLocalization from "../hocs/withLocalization";
import withErrorState from "../hocs/withErrorState";
import withPageInfo from "../hocs/withPageInfo";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import Navigation from "../layouts/Navigation";
import EMobilityTopicIntro from "./EMobilityTopicIntro";
import Heading3 from "../styleguide/Heading3";
import EMobilityChapterCard from "./EMobilityChapterCard";
import withEMobilityTopic from "../hocs/withEMobilityTopic";
import ActionLink from "./ActionLink";
import EMobilityContent from "./EMobilityContent";
import Grid from "@material-ui/core/Grid";

const styles = (theme) => ({
    containerStyle: {
        maxWidth: 1200,
        marginLeft: "auto",
        marginRight: "auto",
        position: "relative",
        paddingBottom: 32,
    },
    heading: {
        marginTop: 24,
        marginBottom: 32,
    },
});

const EMobilityTopic = ({ classes, setPageInfo, eMobilityTopic, generalTranslations }) => {
    useEffect(() => {
        setPageInfo({ parentTitle: eMobilityTopic.title });
    }, []);

    return (
        <React.Fragment>
            <Navigation />
            <div className={classes.mainWrapperStyle}>
                <EMobilityTopicIntro
                    kicker={generalTranslations("topic").toUpperCase()}
                    title={eMobilityTopic.title}
                    number={eMobilityTopic.order}
                    description={eMobilityTopic.intro}
                    image={eMobilityTopic.thumbnail}
                >
                    {eMobilityTopic.eMobilityChapters.map((chapter) => (
                        <ActionLink
                            key={chapter.id}
                            to={`${eMobilityTopic.slug}/${chapter.slug}`}
                            number={`${eMobilityTopic.order}.${chapter.order}`}
                        >
                            {chapter.title}
                        </ActionLink>
                    ))}
                </EMobilityTopicIntro>
                <div className={classes.sectionsWrapperStyle}>
                    <div className={classes.containerStyle}>
                        <Grid container>
                            <Grid item xs md={8}>
                                <EMobilityContent eMobilityContents={eMobilityTopic.eMobilityContents} />
                            </Grid>
                        </Grid>
                        <Heading3>{generalTranslations("topic-content").replace("{0}", eMobilityTopic.title)}</Heading3>
                        {eMobilityTopic.eMobilityChapters.map((chapter) => (
                            <EMobilityChapterCard
                                key={chapter.id}
                                number={`${eMobilityTopic.order}.${chapter.order}`}
                                title={chapter.title}
                                image={chapter.thumbnail}
                                to={`${eMobilityTopic.slug}/${chapter.slug}`}
                                intro={chapter.intro}
                                actionLabel={generalTranslations("more")}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default compose(
    withProps(({ match: { params } }) => {
        return {
            slug: params.topicSlug,
        };
    }),
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    withErrorState,
    withEMobilityTopic(),
    withPageInfo,
    withRouter,
    withStyles(sharedComponentStyles),
    withStyles(styles)
)(EMobilityTopic);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityTopic.js